import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';
import { Subtree } from '../models/node';

@Injectable({
  providedIn: 'root'
})
export class NavigationService {

  public headerMainMenu: Subtree[] = [];
  private history: string[] = [];

  constructor(private router: Router) {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: any) => {
        this.history.push(event.urlAfterRedirects);
      });
  }
  
  public splitUrlRouterLink(url: string): { path: string, queryParams: any } {
    // Separare la stringa del percorso dalla stringa dei query params utilizzando il carattere "?"
    const parts = url ? url.split('?') : '';
    const path = parts[0];
    // Decodificare la stringa dei query params utilizzando la funzione decodeURIComponent() e convertirla in un oggetto
    const queryParams: any = {};
    if (parts.length > 1) {
      const queryParamStrings = parts[1].split('&');
      for (let i = 0; i < queryParamStrings.length; i++) {
        const queryParamParts = queryParamStrings[i].split('=');
        queryParams[decodeURIComponent(queryParamParts[0])] = decodeURIComponent(queryParamParts[1]);
      }
    }
    const decodePath: string = decodeURIComponent(decodeURIComponent(path));
    // Restituire un oggetto contenente il percorso e i query params
    return { path: decodePath, queryParams };
  }

  public getNavigationHistory(): string[] {
    return this.history;
  }

}
